<template>
  <div>
    <section role="form">
      <div class="main-container container container-top">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-content">
                <card-header
                  :titulo="`Aprovação de Férias ${periodoAquisitivo}`"
                />
                <div class="row row-input hidden-xs">
                  <div
                    class="col-xs-4 col-sm-3 filter-element"
                    v-if="comboUors.length > 1"
                  >
                    <div class="form-group">
                      <select
                        class="form-control"
                        v-model="filter.uor"
                        @change="buscaFeriasAgendadas(funcionario, filter)"
                      >
                        <option value="" selected>Unid. Organ.</option>
                        <option
                          v-for="uor in comboUors"
                          :key="uor.id"
                          :value="uor"
                        >
                          {{ uor.sigla }} - {{uor.codigoCentroCusto}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-4 col-sm-3 filter-element">
                    <div class="form-group">
                      <select
                        class="form-control"
                        v-model="filter.status"
                        @change="buscaFeriasAgendadas(funcionario, filter)"
                      >
                        <option value="" selected>Status</option>
                        <option
                          v-for="status in comboStatus"
                          :key="status.name"
                          :value="status"
                        >
                          {{
                            status.displayName &&
                              status.displayName.toUpperCase()
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-3" style="margin-top: -1px">
                    <botao
                      estilo="vazado-verde"
                      rotulo="Limpar"
                      icone="fa-refresh"
                      toggle=""
                      target=""
                      @clicado="limpa()"
                    >
                    </botao>
                  </div>
                  <div class="col-sm-5" style="margin-top: -1px">
                    <p class="alerta">
                      Após aprovação das férias, essa data só poderá ser alterada mediante
                      abertura de processo administrativo.
                    </p>
                  </div>
                </div>
                <div class="row row-input visible-xs">
                  <div class="filter-group">
                    <div class="filter-field" v-if="comboUors.length > 1">
                      <div class="form-group">
                        <select
                          class="form-control"
                          v-model="filter.uor"
                          @change="buscaFeriasAgendadas(funcionario, filter)"
                        >
                          <option value="" selected>Unid. Organ.</option>
                          <option
                            v-for="uor in comboUors"
                            :key="uor.id"
                            :value="uor.sigla"
                          >
                            {{ uor.sigla }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="filter-field-button">
                      <div class="filter-field">
                        <div class="form-group">
                          <select
                            class="form-control"
                            v-model="filter.status"
                            @change="buscaFeriasAgendadas(funcionario, filter)"
                          >
                            <option value="" selected>Status</option>
                            <option
                              v-for="status in comboStatus"
                              :key="status.name"
                              :value="status"
                            >
                              {{
                                status.displayName &&
                                  status.displayName.toUpperCase()
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="filter-button">
                        <botao
                          style="width: 40px"
                          estilo="vazado-verde"
                          rotulo=""
                          icone="fa-refresh"
                          toggle=""
                          target=""
                          @clicado="limpa()"
                        >
                        </botao>
                      </div>
                    </div>
                      <div class="filter-field">
                        <p class="alerta">
                          Após aprovação das férias, essa data só poderá ser alterada mediante
                          abertura de processo administrativo.
                        </p>
                      </div>
                  </div>
                </div>
                <div>
                  <table-loader :carregando="carregando">
                    <div
                      class="alert alert-warning"
                      role="alert"
                      style="text-align: center"
                      v-if="agendamentos && !agendamentos.length"
                    >
                      <i class="fa fa-flag-o fa-lg"></i>&nbsp; Você não tem
                      agendamentos que correspondam com essa busca.
                    </div>
                    <div v-else>
                      <table
                        class="table table-striped table-hover table-standard"
                      >
                        <thead>
                          <tr>
                            <th>Nome</th>
                            <th class="text-center">Dias pendentes</th>
                            <th v-if="temMultiplasUors">Lotação</th>
                            <th v-if="temMultiplosAnos">Ano</th>
                            <th>Início</th>
                            <th>Status</th>
                            <th>&nbsp;</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="ferias in agendamentos"
                            :key="ferias.id"
                            :class="
                              ferias.statusAprovacao === 'EM_ANALISE'
                                ? 'situacao-pendente'
                                : ''
                            "
                          >
                            <td>
                              {{ ferias.nome.toUpperCase() }}
                            </td>
                            <td class="text-center">
                              {{ ferias.possuiDiasPendentes ? 'SIM' : ''}}
                            </td>
                            <td v-if="temMultiplasUors">
                              {{ ferias.lotacao }}
                            </td>
                            <td v-if="temMultiplosAnos">
                              {{ ferias.ano }}
                            </td>
                            <td v-if="ferias.dataInicioFerias">
                              {{ ferias.dataInicioFerias | formataData }}
                            </td>
                            <td v-else>
                              <i
                                class="fa fa-ellipsis-h fa-lg"
                                aria-hidden="true"
                              ></i>
                            </td>
                            <td>
                              {{ ferias.statusAprovacao | descricaoStatus }}
                            </td>
                            <td class="td-btns">
                              <botao
                                estilo="vazado-vermelho-sm"
                                icone="fa fa-close fa-lg"
                                v-tooltip.left="'Reprovar'"
                                @clicado="reprovar(ferias)"
                                :disabled="desabilitaAprovacaoOuReprovacao(ferias)"
                              >
                              </botao>
                              <botao
                                estilo="vazado-verde-sm"
                                icone="fa fa-check fa-lg"
                                v-tooltip.right="'Aprovar'"
                                @clicado="aprovar(ferias)"
                                :disabled="desabilitaAprovacaoOuReprovacao(ferias)"
                              >
                              </botao>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table
                        class="table table-striped table-hover table-cards"
                      >
                        <thead>
                          <tr>
                            <th>Agendamentos</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="ferias in agendamentos"
                            :key="ferias.id"
                            :class="
                              ferias.statusAprovacao === 'EM_ANALISE'
                                ? 'situacao-pendente'
                                : ''
                            "
                          >
                            <td>
                              <div class="name">
                                {{ ferias.nome.toUpperCase() }}
                              </div>

                              <div class="legends">
                                <div v-if="temMultiplasUors">Lotação:</div>
                                <div v-if="temMultiplosAnos">Ano:</div>
                                <div>Férias:</div>
                                <div>Status:</div>
                                <div>Dias pendentes:</div>
                              </div>
                              <div class="values">
                                <div v-if="temMultiplasUors">
                                  {{ ferias.lotacao }}
                                </div>
                                <div v-if="temMultiplosAnos">
                                  {{ ferias.ano }}
                                </div>
                                <div v-if="ferias.dataInicioFerias">
                                  {{ ferias.dataInicioFerias | formataData }}
                                </div>
                                <div v-else>
                                  <i
                                    class="fa fa-ellipsis-h fa-lg"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <div>
                                  {{ ferias.statusAprovacao | descricaoStatus }}
                                </div>
                                <div>
                                  {{ ferias.possuiDiasPendentes ? 'SIM' : ''}}
                                </div>
                              </div>
                              <div class="td-btns actions">
                                <botao
                                  estilo="vazado-vermelho-sm"
                                  icone="fa fa-close fa-lg"
                                  v-tooltip.left="'Reprovar'"
                                  @clicado="reprovar(ferias)"
                                  :disabled="desabilitaAprovacaoOuReprovacao(ferias)"
                                >
                                </botao>
                                <botao
                                  estilo="vazado-verde-sm"
                                  icone="fa fa-check fa-lg"
                                  v-tooltip.right="'Aprovar'"
                                  @clicado="aprovar(ferias)"
                                  :disabled="desabilitaAprovacaoOuReprovacao(ferias)"
                                >
                                </botao>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div
                        class="col-xs-12 col-sm-offset-4 col-sm-4 footer-controller-inner footer-center"
                      >
                        <botao
                          id="mais-resultados"
                          tipo="button"
                          estilo="vazado-verde-dir"
                          rotulo="Mais resultados"
                          v-if="!paginacao.ultimo"
                          style="margin-left: 0"
                          icone="fa-chevron-down"
                          @clicado="listaMaisResultados(funcionario, filter)"
                        >
                        </botao>
                      </div>
                      <div class="col-xs-12 col-sm-4 footer-controller-inner">
                        <botao
                          estilo="cheio-verde-dir"
                          rotulo="Imprimir"
                          icone="imprimir-tabela"
                          @clicado="imprime(funcionario.id, filter)"
                        >
                        </botao>
                      </div>
                    </div>
                  </table-loader>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Botao from '@/components/botao';
import CardHeader from '@/components/card-header';
import TableLoader from '@/components/table-loader';
import feriasAgendadasMock from '../../../static/support/sample-data/feriasAgendadas';
import maisFeriasAgendadasMock from '../../../static/support/sample-data/maisFeriasAgendadas';
import Agendamento from '@/domain/ferias/agendamento';
import DateHelper from '@/helpers/DateHelper.js';
import ErrorHelper from '@/helpers/ErrorHelper';
import moment from 'moment';
import api from '@/services/api';
import obtemImpressao from '@/services/obtemImpressao';

export default {
  name: 'Aprovacao',

  data() {
    return {
      apiErrors: null,
      carregando: true,
      funcionario: {},
      periodoAquisitivo: '',
      agendamentos: [],
      agendamentosDaApi: [],
      statusDefault: 'APROVADA,REPROVADA,EM_ANALISE,PENDENTE,MARCADA,SEGUNDA_APROVACAO',
      resultadoDaBusca: [],
      filter: {
        uor: '',
        status: '',
      },
      comboStatus: [],
      comboUors: [],
      paginacao: {
        ultimo: false,
        numero: 0,
      },
    };
  },
  filters: {
    descricaoStatus(status) {
      let descricao = status;

      switch(status) {
        case 'EM_ANALISE': descricao = 'EM ANÁLISE'; break;
        case 'SEGUNDA_APROVACAO': descricao = 'SEGUNDA APROVAÇÃO'; break;
        case 'MARCADA': descricao = 'MARCADA/GOZADA'; break;
      }

      return descricao;
    }
  },
  computed: {
    temMultiplasUors() {
      return this.comboUors && this.comboUors.length > 1;
    },
    temMultiplosAnos() {
      const anos = this.agendamentos
        .map(item => item.ano)
        .filter((item, index, array) => array.indexOf(item) === index);

      return anos && anos.length > 1;
    },
    usuarioAtual() {
      return this.$store.state.funcionario;
    },
    usuarioLogado() {
      return this.$store.state.usuarioLogado;
    },
  },
  watch: {
    usuarioAtual(novo, anterior) {
      this.funcionario = novo;
      this.listaAgendamentosNaTela(novo);
    },
  },
  methods: {
    desabilitaAprovacaoOuReprovacao(ferias) {
      const esperandoDuplaAprovacao = ferias.statusAprovacao === 'SEGUNDA_APROVACAO' &&
        (ferias.idFuncionarioResponsavel == this.funcionario.id ||
         ferias.idFuncionarioResponsavelSegundo == this.funcionario.id);


      return ferias.statusAprovacao === 'APROVADA' ||
        ferias.statusAprovacao === 'PENDENTE' ||
        ferias.statusAprovacao === 'REPROVADA' ||
        ferias.statusAprovacao === 'MARCADA' ||
        esperandoDuplaAprovacao
    },

    // Métodos de input
    async imprime(funcionarioId, filter) {
      const endPoint = `agendamentos-ferias/relatorio`;
      const { uor, status } = filter;
      const params = {
        idFuncionarioResponsavel: funcionarioId,
        idUnidadeOrganizacional: uor && uor.id,
        status: status ? status.name : this.statusDefault,
      };

      try {
        await obtemImpressao(endPoint, params);
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        if (mensagem === 'Desbloqueie as pop-ups para este site') {
          this.$root.$refs.toastr.w(mensagem, 'Pop-up bloqueada');
        }
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    async reprovar(ferias) {
      const bloqueiaPorDataLancamento = await this.bloqueiaPorDataLancamento();

      if (bloqueiaPorDataLancamento) return;

      const reprovaTodas = this.validaReprovaAnteriorEPosterior(ferias);

      const mensagemTodas =
        `Para evitar conflitos de reagendamento, não aprovar as férias de ` +
        `${ferias.ano} reprovará, automaticamente, as férias de ` +
        `${ferias.ano + 1}. Deseja reprovar o agendamento escolhido?`;

      const mensagemSimples = 'Deseja reprovar a data escolhida pelo servidor?';

      const sentences = [
        {
          id: 1,
          message: reprovaTodas ? mensagemTodas : mensagemSimples,
          bold: true,
        },
      ];

      this.$root.$refs.modal.confirm(sentences, {
        yes: async () => {
          const agendamento = this.agendamentosDaApi.find(
            agendamento => agendamento.id === ferias.id,
          );
          const agendamentoParaEnvio = this.mapeiaAgendamentoParaEnvio(
            agendamento,
            'REPROVADA',
          );

          const response = await this.gravaStatusEscolhido(
            agendamentoParaEnvio,
            this.funcionario.id,
          );

          this.buscaFeriasAgendadas(this.funcionario, this.filter);
        },
        title: 'Reprovar Agendamento',
      });
    },
    async aprovar(ferias) {
      const bloqueiaPorDataLancamento = await this.bloqueiaPorDataLancamento();

      if (bloqueiaPorDataLancamento) return;

      let mensagem = 'Deseja aprovar a data escolhida pelo servidor?';

      if(ferias.possuiDiasPendentes) {
        mensagem = "Este servidor possui dias pendentes que devem ser gozados antes do " +
          "gozo das próximas férias regulares. Deseja prosseguir com a aprovação?";
      }

      const sentences = [
        {
          id: 1,
          message: mensagem,
          bold: true,
        },
      ];

      this.$root.$refs.modal.confirm(sentences, {
        yes: async () => {
          const agendamento = this.agendamentosDaApi.find(
            agendamento => agendamento.id === ferias.id,
          );
          const agendamentoParaEnvio = this.mapeiaAgendamentoParaEnvio(
            agendamento,
            'APROVADA',
          );

          const response = await this.gravaStatusEscolhido(
            agendamentoParaEnvio,
            this.funcionario.id,
          );

          this.atualizaFeriasNaTela(ferias, response);
        },
        title: 'Aprovar Agendamento',
      });


    },
    async listaMaisResultados(funcionario, filter) {
      const { uor, status } = filter;
      const pagina = this.paginacao.numero + 1;
      const params = {
        idFuncionarioResponsavel: funcionario.id,
        idUnidadeOrganizacional: uor && uor.id,
        status: status ? status.name : this.statusDefault,
        page: pagina,
        size: 50,
      };

      await this.listaAgendamentos(funcionario, params, 'mais resultados');

      const botaoMaisResultados = document.querySelector('#mais-resultados');
      botaoMaisResultados &&
        botaoMaisResultados.scrollIntoView({ behavior: 'smooth' });
    },
    async buscaFeriasAgendadas(funcionario, filter) {
      this.carregando = true;

      const { uor, status } = filter;
      const params = {
        idFuncionarioResponsavel: funcionario.id,
        idUnidadeOrganizacional: uor && uor.id,
        status: status ? status.name : this.statusDefault,
        size: 50,
      };

      await this.listaAgendamentos(funcionario, params, 'filtrados');

      this.carregando = false;
    },

    // Métodos de validações
    verificaSeEhAprovador() {
      if (this.usuarioLogado.perfis) {
        return this.usuarioLogado.perfis.includes('APROVADOR_AGENDAMENTO_FERIAS');
      }

      return false;
    },
    bloqueiaSeNaoEhAprovador() {
      const ehResponsavelAprovador = this.verificaSeEhAprovador();

      if (!ehResponsavelAprovador) {
        this.$router.push({ name: 'SemAcesso' });
        return true;
      }

      return false;
    },
    async bloqueiaPorDataLancamento() {
      const endPointPeriodos = `agendamentos-ferias/funcionarios/${
        this.funcionario.id
      }/competencias`;
      const response = await api.get(endPointPeriodos);
      const periodoEstahFechado = !moment().isBetween(
        response.periodos[0].dataInicioLancamento,
        response.periodos[0].dataFimLancamento,
        'day', '[]'
      );

      if (periodoEstahFechado) {
        this.$root.$refs.toastr.w(
          'Período de aprovação de férias fechado',
          'Atenção',
        );
        return true;
      }

      return false;
    },

    // Métodos de requisição
    async listaAgendamentos(funcionario, parametros, tipoDeResultado) {
      try {
        const endPoint = 'agendamentos-ferias';
        const queryParams = { params: parametros };

        const response = await api.get(endPoint, queryParams);
        const agendamentosMapeados = this.mapeiaAgendamentos(response.content);
        const agendamentosOrdenados = this.ordenaFeriasListadas(
          agendamentosMapeados,
        );

        if (tipoDeResultado === 'mais resultados') {
          this.agendamentos = [...this.agendamentos, ...agendamentosOrdenados];
          this.agendamentosDaApi = [
            ...this.agendamentosDaApi,
            ...response.content,
          ];
        } else {
          this.agendamentosDaApi = [...response.content];
          this.agendamentos = [...agendamentosOrdenados];
        }

        this.paginacao.ultimo = response.last;
        this.paginacao.numero = response.number;
      } catch (error) {
        this.$root.$refs.toastr.e(error.data[0].message, 'Atenção');
        this.carregando = false;
      }
    },
    async listaStatus() {
      const endPoint = 'agendamentos-ferias/status-aprovacoes';

      const situacoes = await api.get(endPoint);
      const situacoesOrdenadas = this.ordenaStatus(situacoes);

      this.comboStatus = [...situacoesOrdenadas];
    },
    async obtemMesCompetencia(funcionarioId) {
      try {
        const endPointCompetencias = `agendamentos-ferias/funcionarios/${funcionarioId}/competencias`;
        const competencia = await api.get(endPointCompetencias);
        
        if (!competencia.id) {
          this.$root.$refs.toastr.e(
            'Não encontramos os dados do mês que ' +
            'compete ao agendamento. Por favor, avise ao DETIC sobre essa mensagem',
            'Atenção',
            );
            
            return;
          }
          
        if (!competencia.acessaAgendamento) {
          this.$router.push({ name: 'UorNaoParticipante' });
          this.usuarioValido = false;
          
          return;
        }
        
        this.periodoAquisitivo = competencia.ano;
        
        return competencia;
      } catch (error) {
        const message = error.data[0].message;
        
        if (message === 'Funcionário não localizado ou acesso negado') {
          this.$router.push({ name: 'UorNaoParticipante' });
          this.usuarioValido = false;
          throw error;
        }
        
        if (message === 'Agendamento de Férias está fechado para lançamento') {
          this.carregandoAprovador = false;
          this.escondeAprovador = true;
          this.$router.push({ name: 'PeriodoEncerrado' });
          throw error;

        }
            
        this.$root.$refs.toastr.e(message, 'Atenção');
      }
    },
    async listaUors(funcionarioId) {
      try {
        const competencia = await this.obtemMesCompetencia(funcionarioId);

        const endPoint =
          `/agendamentos-ferias/funcionarios/${funcionarioId}` +
          `/competencias/${competencia.id}/unidades-organizacionais`;

        const uors = await api.get(endPoint);
        const uorsOrdenadas = this.ordenaUors(uors);

        this.comboUors = [...uorsOrdenadas];
      } catch (error) {
        this.$root.$refs.toastr.e(error.data[0].message, 'Atenção');
      }
    },
    async gravaStatusEscolhido(agendamento, funcionarioId) {
      try {
        const endPoint = `agendamentos-ferias/${agendamento.id}`;
        const queryParams = {
          params: {
            idFuncionarioResponsavel: funcionarioId,
          },
        };

        const response = await api.put(endPoint, agendamento, queryParams);

        let mensagem = '';

        if(response.statusAprovacao === 'SEGUNDA_APROVACAO') {
          mensagem = 'É necessário mais uma aprovação para este funcionário';
        } else if(agendamento.statusAprovacao === 'APROVADA') {
          mensagem = 'Aprovação registrada';
        } else {
          mensagem = 'Reprovação registrada';
        }

        this.$root.$refs.toastr.s(mensagem, 'Sucesso');

        return response;
      } catch (error) {
        this.$root.$refs.toastr.e(error.data[0].message, 'Atenção');
      }
    },

    // Outros métodos
    async listaAgendamentosNaTela(funcionario) {
      if (this.bloqueiaSeNaoEhAprovador()) return;

      this.carregando = true;

      const params = {
        idFuncionarioResponsavel: funcionario.id,
        status: this.statusDefault,
        size: 50,
      };

      await this.listaAgendamentos(funcionario, params, 'primeira tela');

      this.carregando = false;
    },
    mapeiaAgendamentos(agendamentos) {
      const feriasMapeadas = [];

      agendamentos.map(agendamento => {
        const ferias = new Agendamento(
          agendamento.id,
          agendamento.periodoAquisitivo.funcionario.nome,
          agendamento.periodoAquisitivo.possuiDiasPendentes,
          agendamento.periodoAquisitivo.funcionario.unidadeOrganizacional.sigla,
          agendamento.periodoAquisitivo.competencia.ano,
          agendamento.dataInicio,
          agendamento.statusAprovacao,
          agendamento.responsavelAprovacao ? agendamento.responsavelAprovacao.funcionarioResponsavel.id : null,
          agendamento.responsavelSegundoAprovador ? agendamento.responsavelSegundoAprovador.funcionarioResponsavel.id : null,
        );

        feriasMapeadas.push(ferias);
      });

      return feriasMapeadas;
    },
    mapeiaAgendamentoParaEnvio(agendamento, status) {
      const mapeado = { periodo: {}, periodoAquisitivo: {} };

      mapeado.id = agendamento.id;
      mapeado.periodo.id = agendamento.periodo.id;
      mapeado.periodoAquisitivo.id = agendamento.periodoAquisitivo.id;
      mapeado.dataInicio = agendamento.dataInicio;
      mapeado.dataAgendamento = agendamento.dataAgendamento;
      mapeado.statusAprovacao = status;
      mapeado.dataAprovacao = null;
      mapeado.responsavelAprovacao = null;

      return mapeado;
    },
    ordenaFeriasListadas(agendamentos) {
      if (agendamentos.length) {
        const agendamentosOrdenados = agendamentos.sort((a, b) => {
          if (a.nome > b.nome) return 1;
          if (a.nome < b.nome) return -1;
          if (a.id > b.id) return 1;
          if (a.id < b.id) return -1;
        });

        return agendamentosOrdenados;
      }

      return agendamentos;
    },
    ordenaStatus(situacoes) {
      if (situacoes.length) {
        const situacoesOrdenados = situacoes.sort((a, b) => {
          if (a.name > b.name) return 1;
          if (a.name < b.name) return -1;
        });

        return situacoesOrdenados;
      }

      return situacoes;
    },
    ordenaUors(uors) {
      if (uors.length) {
        const uorsOrdenados = uors.sort((a, b) => {
          if (a.sigla > b.sigla) return 1;
          if (a.sigla < b.sigla) return -1;
        });

        return uorsOrdenados;
      }

      return uors;
    },
    limpa() {
      this.filter.uor = '';
      this.filter.status = '';
      this.buscaFeriasAgendadas(this.funcionario, this.filter);
    },
    mostraAvisoBloqueadoPorData() {
      if (
        !sessionStorage.mostraForaDataAprovacao &&
        this.bloqueiaPorDataLancamento()
      ) {
        sessionStorage.setItem('mostraForaDataAprovacao', true);
      }
    },
    atualizaFeriasNaTela(ferias, response) {
      const index = this.agendamentos.indexOf(ferias);
      let agendamento = this.agendamentos[index];

      agendamento.statusAprovacao = response.statusAprovacao;
      agendamento.idFuncionarioResponsavel = response.responsavelAprovacao ? response.responsavelAprovacao.funcionarioResponsavel.id : null;
      agendamento.idFuncionarioResponsavelSegundo = response.responsavelSegundoAprovador ? response.responsavelSegundoAprovador.funcionarioResponsavel.id : null;
    },
    validaReprovaAnteriorEPosterior(ferias) {
      const anoAtual = moment().year();

      const posteriorAprovada = this.agendamentos.find(
        item =>
          item.nome === ferias.nome &&
          item.ano === ferias.ano + 1 &&
          (item.statusAprovacao === 'EM_ANALISE' ||
            item.statusAprovacao === 'APROVADA'),
      );

      if (ferias.ano === anoAtual && posteriorAprovada) return true;

      return false;
    },
  },
  created() {
    this.funcionario = this.$store.state.funcionario;
    this.mostraAvisoBloqueadoPorData();
    this.listaAgendamentosNaTela(this.funcionario);
    this.listaUors(this.funcionario.id);
    this.listaStatus();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  components: {
    Botao,
    CardHeader,
    TableLoader,
  },
};
</script>

<style scoped>
.filter-group {
  display: flex;
  flex-wrap: wrap;
  max-width: 520px;
}
.filter-field {
  min-width: 225px;
  padding: 0 15px;
}
.filter-button {
  margin-top: -1px;
  padding: 0 15px;
}
.filter-field-button {
  display: flex;
}
.btn-primary:disabled {
  background-color: transparent;
  border-color: #64a357;
  color: #64a357;
}
.btn-danger:disabled {
  background-color: transparent;
  border-color: #923936;
  color: #923936;
}
.form-control {
  min-width: 66px !important;
}
.table-cards {
  display: none;
}
.table-cards th {
  font-size: 1.5rem;
}
.table-cards tr {
  padding: 0;
}
.table-cards td {
  display: grid;
  grid-template-columns: 100px auto 107px;
  grid-template-rows: auto auto;
}
.table-cards .name {
  font-size: 1.6rem;
  grid-column: 1 / span 3;
  grid-row: 1;
}
.table-cards .legends {
  font-size: 1.3rem;
  grid-column: 1;
  grid-row: 2;
}
.table-cards .values {
  margin-left: 15px;
  line-height: 1.3;
  grid-column: 2;
  grid-row: 2;
}
.table-cards .actions {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  grid-column: 3;
  grid-row: 2;
}
.table-cards .actions button {
  margin-left: 4px;
  margin-bottom: 3px;
}
.alerta {
  color: #FF3C3C;
  font-weight: bold;
}
@media screen and (max-width: 600px) {
  .filter-group {
    max-width: 520px;
  }
  .filter-field {
    min-width: 210px;
    padding: 0 0 0 15px;
  }
  .filter-button {
    padding: 0 15px;
  }
  .table-standard {
    display: none;
  }
  .table-cards {
    display: table;
  }
  .table-cards-btns {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .btn-primary {
    margin-bottom: 0;
  }
}
@media screen and (max-width: 440px) {
  .card-content {
    padding: 0 15px;
  }
  .table-cards td {
    grid-template-columns: 60px auto 90px;
  }
  .td-btns {
    width: 90px;
  }
}
</style>



// WEBPACK FOOTER //
// aprovacao.vue?45304ec2